export default defineNuxtPlugin(() => {
  const router = useRouter();

  router.beforeResolve((_to, _from, next) => {
    // パンくずリストを初期化
    _from.meta.pageBreadcrumbs = [];
    next();
  });
});
